import { Navigate, useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";
import { Card, Space, Typography } from "antd";

import { getFileById } from "../api/fileAPI";
import { FileForm } from "../components/FileForm";

const { Title } = Typography;

const UpdateFile = () => {
  const { id } = useParams();
  const fileId = id;

  const { data: fileData, isLoading } = useQuery({
    queryKey: ["file", fileId],
    queryFn: () => getFileById(fileId),
    enabled: !!fileId,
  });

  if (!fileId) {
    return <Navigate to="/404" replace />;
  }

  return (
    <Space
      direction="vertical"
      style={{ margin: 10, width: "-webkit-fill-available" }}
    >
      <Card>
        <Title level={3} style={{ marginBottom: "1em" }}>
          Update File Information
        </Title>
        <Title
          level={5}
          style={{ color: "#0C377C", textTransform: "uppercase" }}
        >
          File Information
        </Title>

        {!isLoading && (
          <FileForm
            initialData={{
              ...fileData,
              branchId: fileData?.branch?.id || fileData?.branchId,
              agentId: fileData?.agent?.id || fileData?.agentId,
              clientId: fileData?.client?.id || fileData?.clientId,
              purchaserId: fileData?.purchaser?.id || fileData?.purchaserId,
              vendorId: fileData?.vendor?.id || fileData?.vendorId,
            }}
            mode="update"
            fileId={fileId}
          />
        )}
      </Card>
    </Space>
  );
};

export default UpdateFile;
